export const SET_PAYROLL_LOADING = 'SET_PAYROLL_LOADING'
export const SET_PAYROLL = 'SET_PAYROLL'
export const ADD_PAYROLL = 'ADD_PAYROLL'
export const EDIT_PAYROLL = 'EDIT_PAYROLL'
export const DELETE_PAYROLL= 'DELETE_PAYROLL'
export const SET_PAYROLL_ASSIGN_USERS = 'SET_PAYROLL_ASSIGN_USERS'